// extracted by mini-css-extract-plugin
export default {"menuHeader":"menuHeader___hCzAe","menuHeader_title":"menuHeader_title___oKHry"};